/* Funkcje zaznaczające checki w sekcjach, zliczajace wszystkie pytania itp z czwartego kroku km */

$(document).ready(function () {
    if ($('.p__path--fourth').length) {
        let divNameStr = 'app_conversion_path_fourth_step';
        let healthDataUrl = 'app_conversion_path_health_conf';

        if ($('.p__path--second').length) {
            divNameStr = 'app_conversion_path_second_step_haquestionnaire';
            healthDataUrl = 'interactivo_partner_conversion_path_health_conf';
        }

        let healthData;
        // Zaciaganie configa /komunikaty/
        $.get(Routing.generate(healthDataUrl, {_locale: currentLocale,}))
            .done(function (data) {
                healthData = data;

                for (let name in healthData) {
                    if (healthData.hasOwnProperty(name)) {
                        let $divName = $('#' + divNameStr + '_' + name);

                        if ($divName.children('input:radio:checked').length > 0) {
                            let healthConf = healthData[name];
                            let healthVal = parseInt($divName.children('input:radio:checked').val());

                            if (healthConf.hasOwnProperty('status') && healthConf.hasOwnProperty('restrictions') && healthConf.hasOwnProperty('modal_section') && healthConf.hasOwnProperty('messages')) {
                                if (Object.keys(healthConf['messages']).length > 0) {
                                    $divName.find('.infoBar').remove();

                                    if (healthConf['restrictions'].length > 0) {
                                        if (healthConf['messages'].hasOwnProperty(healthVal)) {
                                            let showMessage = false;
                                            healthConf['restrictions'].forEach(function (item) {
                                                if (showMessage === false) {
                                                    if (parseInt($('.p__path--fourth').attr('data-' + item)) === 1) {
                                                        showMessage = true;
                                                    }
                                                }
                                            });
                                            if (showMessage) {
                                                $divName.after('<div class="infoBar"><p>' + jsTranslations['messages'][healthConf['messages'][healthVal]] + '</p></div>');
                                            }
                                        }
                                    } else {
                                        if (healthConf['messages'].hasOwnProperty(healthVal)) {
                                            $divName.after('<div class="infoBar"><p>' + jsTranslations['messages'][healthConf['messages'][healthVal]] + '</p></div>');
                                        }
                                    }
                                }
                            }
                        }


                    }
                }

                $('.siteLoaderFourth').fadeOut(500, function () {
                    $(this).remove();
                });
            });

        // Understand lightbox

        $('.understandCheck').on('change', function() {
           let $that = $(this);
           $that.closest('.lightbox_wrapper').fadeOut(300, function() {
               $that.prop('checked', false);
           });
        });


        /* Licznik */
        var counter = 0;
        var counterMisc = 0;
        var counterLyme = 0;
        var counterAll = 0;
        var overallCount = 0;
        var currentCounter = $('#currentCounter');
        var overallCounter = $('#overallCounter');
        var arr = [];
        var arr_checked = [];
        var arr_checked_misc = [];
        var arr_checked_lyme = [];
        var arr_misc = [];
        var arr_lyme = [];
        arr_checked[-1] = 1;

        function addCheck(target) {
            var name = $(target).attr('name');
            var dataCount = $(target).attr('data-count');
            // Znajdujemy pozycje tego name'a w tablicy
            if (dataCount == 'misc') {
                var position = $.inArray(name, arr_misc);
                if (arr_checked_misc[position] == null) {
                    counterMisc++;
                    arr_checked_misc[position] = 1;
                } else {
                }
                ;
            } else if (dataCount == 'lyme') {
                var position = $.inArray(name, arr_lyme);
                if (arr_checked_lyme[position] == null) {
                    counterLyme++;
                    arr_checked_lyme[position] = 1;
                } else {
                }
                ;
            } else {
                var position = $.inArray(name, arr);
                // Sprawdzmy czy pozycja w arr_checked ma wartosc null czy nie
                if (arr_checked[position] == null) {
                    // Podbijamy counter i wstrzykujemy go do CurrentCounter'a i ustawiamy arr_checked o danej pozycji na 1
                    counter++;
                    currentCounter.html(counter);
                    arr_checked[position] = 1;
                } else {
                }
                ;
            }

            if ($('#' + divNameStr + '_bbe80691_0').is(':checked') || $('#' + divNameStr + '_c228a33a_0').is(':checked')) {
                overallCount = arr.length;

                if ($('#' + divNameStr + '_bbe80691_0').is(':checked')) {
                    overallCount += arr_misc.length;
                }
                if ($('#' + divNameStr + '_c228a33a_0').is(':checked')) {
                    overallCount += arr_lyme.length;
                }
            } else overallCount = arr.length;

            counterAll = counter + counterMisc + counterLyme;
            currentCounter.html(counterAll);

            if (counterAll >= overallCount) {
                counterAll = overallCount;
                currentCounter.html(counterAll);
                $('.counterFourth').addClass('finished');
            } else {
                $('.counterFourth').removeClass('finished');
            }
        }

        function removeCheck(target) {
            var name = $(target).attr('name');
            var dataCount = $(target).attr('data-count');
            if (dataCount == 'misc') {
                var position = $.inArray(name, arr_misc);
                if (arr_checked_misc[position] == 1) {
                    counterMisc--;
                    arr_checked_misc[position] = null;
                } else {
                }
                ;
            }

            if (dataCount == 'lyme') {
                var position = $.inArray(name, arr_lyme);
                if (arr_checked_lyme[position] == 1) {
                    counterLyme--;
                    arr_checked_lyme[position] = null;
                } else {
                }
                ;
            }

            counterAll = counter + counterMisc + counterLyme;
            currentCounter.html(counterAll);

            overallCount = arr.length;

            if ($('#' + divNameStr + '_bbe80691_0').is(':checked')) {
                overallCount += arr_misc.length;
            }
            if ($('#' + divNameStr + '_c228a33a_0').is(':checked')) {
                overallCount += arr_lyme.length;
            }

            if (counterAll >= overallCount) {
                counterAll = overallCount;
                currentCounter.html(counterAll);
                $('.counterFourth').addClass('finished');
            } else {
                $('.counterFourth').removeClass('finished');
            }
        }

        // Tworzymy tablice z unikalnych name'ow inputow radio
        $.each($('input[name*=' + divNameStr + ']:radio'), function () {
            if ($(this).attr('data-count') == 'misc') {
                var mynameMisc = this.name;
                if ($.inArray(mynameMisc, arr_misc) < 0) {
                    arr_misc.push(mynameMisc);
                }
            } else if ($(this).attr('data-count') == 'lyme') {
                var mynameLyme = this.name;
                if ($.inArray(mynameLyme, arr_lyme) < 0) {
                    arr_lyme.push(mynameLyme);
                }
            } else {
                var myname = this.name;
                if ($.inArray(myname, arr) < 0) {
                    arr.push(myname);
                }
            }

        });

        function prepareOverall() {
            // Bierzemy liczbe unikalnych name'ow i wstrzykujemy w overallCounter
            // Jesli poronienie lub borelioza jest zaznaczone, to dodajemy takze tablice z tymi pytaniami
            if ($('#' + divNameStr + '_bbe80691_0').is(':checked') || $('#' + divNameStr + '_c228a33a_0').is(':checked')) {
                let overallCount = arr.length;

                if ($('#' + divNameStr + '_bbe80691_0').is(':checked')) {
                    overallCount += arr_misc.length;
                }
                if ($('#' + divNameStr + '_c228a33a_0').is(':checked')) {
                    overallCount += arr_lyme.length;
                }
                overallCounter.html(overallCount);

                for (var i = 0; i <= arr.length; i++) {
                    var nameCheck = arr[i];
                    if ($('input[name="' + nameCheck + '"]').is(':checked')) {
                        addCheck('input[name="' + nameCheck + '"]');
                    }
                }

                if ($('#' + divNameStr + '_bbe80691_0').is(':checked')) {
                    for (var i = 0; i <= arr_misc.length; i++) {
                        var nameCheck = arr_misc[i];
                        if ($('input[name="' + nameCheck + '"]').is(':checked')) {
                            addCheck('input[name="' + nameCheck + '"]');
                        }
                    }
                }
                if ($('#' + divNameStr + '_c228a33a_0').is(':checked')) {
                    for (var i = 0; i <= arr_lyme.length; i++) {
                        var nameCheck = arr_lyme[i];
                        if ($('input[name="' + nameCheck + '"]').is(':checked')) {
                            addCheck('input[name="' + nameCheck + '"]');
                        }
                    }
                }
            } else {
                overallCounter.html(arr.length);
                for (var i = 0; i <= arr.length; i++) {
                    var nameCheck = arr[i];
                    if ($('input[name="' + nameCheck + '"]').is(':checked')) {
                        addCheck('input[name="' + nameCheck + '"]');
                    }
                }
            }
        }

        // wywolanie na starcie
        prepareOverall();


        // Na zmiane wartosci konkretnego inputa
        $('input[id*=' + divNameStr + ']:radio').on("change", function () {
            addCheck(this);
            prepareOverall();

            // sprawdzanie komunikatu z konfiga
            let name = '';
            if (divNameStr === 'app_conversion_path_second_step_haquestionnaire') {
                name = $(this).attr('name').substring($(this).attr('name').indexOf('[') + 18, $(this).attr('name').indexOf('[') + 26);
            } else {
                name = $(this).attr('name').substring($(this).attr('name').indexOf('[') + 1, $(this).attr('name').indexOf('[') + 9);
            }
            let that = $(this);

            if (healthData.hasOwnProperty(name)) {
                let healthConf = healthData[name];
                let healthVal = parseInt(that.val());

                if (healthConf.hasOwnProperty('status') && healthConf.hasOwnProperty('restrictions') && healthConf.hasOwnProperty('modal_section') && healthConf.hasOwnProperty('messages')) {
                    if (healthConf['modal_section'] !== false) {
                        let modals = [];

                        $.each(healthConf['modal_section'], function (key, value) {
                            if (value.hasOwnProperty(healthVal)) {
                                if (key === 'all') {
                                    if (!modals.includes(value[healthVal])) {
                                        modals.push(value[healthVal]);
                                    }
                                } else {
                                    if (parseInt($('.p__path--fourth').attr('data-' + key)) === 1) {
                                        if (!modals.includes(value[healthVal])) {
                                            modals.push(value[healthVal]);
                                        }
                                    }
                                }
                            }
                        });

                        modals.forEach(function (item) {
                            $('.lightbox_wrapper[data-section="' + item + '"]').fadeIn(300);
                        });
                    }

                    if (Object.keys(healthConf['messages']).length > 0) {
                        that.parent().parent().find('.infoBar').remove();

                        if (healthConf['restrictions'].length > 0) {
                            if (healthConf['messages'].hasOwnProperty(healthVal)) {
                                let showMessage = false;
                                healthConf['restrictions'].forEach(function (item) {
                                    if (showMessage === false) {
                                        if (parseInt($('.p__path--fourth').attr('data-' + item)) === 1) {
                                            showMessage = true;
                                        }
                                    }
                                });
                                if (showMessage) {
                                    that.parent().after('<div class="infoBar"><p>' + jsTranslations['messages'][healthConf['messages'][healthVal]] + '</p></div>');
                                }
                            }
                        } else {
                            if (healthConf['messages'].hasOwnProperty(healthVal)) {
                                that.parent().after('<div class="infoBar"><p>' + jsTranslations['messages'][healthConf['messages'][healthVal]] + '</p></div>');
                            }
                        }
                    }
                }
            }


        });


        /* Poronienie */
        $('[name=' + divNameStr + '\\[bbe80691\\]]').on("change", function () {
            var $yes = $('#' + divNameStr + '_bbe80691_yes');
            if ($('#' + divNameStr + '_bbe80691_0').is(':checked')) {
                $yes.slideDown(300);
            } else {
                $yes.find('input').each(function (index) {
                    if (index === 1) {
                        $(this).prop('checked', true).trigger("change");
                    }
                    removeCheck($(this));
                    $(this).prop('checked', false);
                });
                $yes.slideUp(300);

            }
        });

        /* Borelioza (choroba z Lyme) */
        $('[name=' + divNameStr + '\\[c228a33a\\]]').on("change", function () {
            var $yes = $('#' + divNameStr + '_c228a33a_yes');
            if ($('#' + divNameStr + '_c228a33a_0').is(':checked')) {
                $yes.slideDown(300);
            } else {
                $yes.find('input').each(function (index) {
                    if (index === 1) {
                        $(this).prop('checked', true).trigger("change", [true]);
                    }
                    removeCheck($(this));
                    $(this).prop('checked', false);
                });
                $yes.slideUp(300);

            }
        });

        /* Czy ciąża jest wynikiem zabiegu zapłodnienia in vitro? */
        $('[name=' + divNameStr + '\\[fb2cde49\\]]').on("change", function () {
            var $yes = $('#' + divNameStr + '_fb2cde49_yes');
            var $no = $('#' + divNameStr + '_a1790811_no');
            if ($('#' + divNameStr + '_fb2cde49_0').is(':checked')) {
                $yes.slideDown(300);
            } else {
                $yes.find('input').each(function (index) {
                    if (index === 1) {
                        $(this).prop('checked', true).trigger("change", [true]);
                    }
                    removeCheck($(this));
                    $(this).prop('checked', false);
                });
                $yes.slideUp(300);
                $no.find('input').each(function (index) {
                    if (index === 1) {
                        $(this).prop('checked', true).trigger("change", [true]);
                    }
                    removeCheck($(this));
                    $(this).prop('checked', false);
                });
                $no.slideUp(300);
            }
        });

        /* Czy ciąża jest wynikiem zabiegu zapłodnienia in vitro komórek pochodzących od rodziców biologicznych? */
        $('[name=' + divNameStr + '\\[a1790811\\]]').on("change", function () {
            var $no = $('#' + divNameStr + '_a1790811_no');
            if ($('#' + divNameStr + '_a1790811_1').is(':checked')) {
                $no.slideDown(300);
            } else {
                $no.find('input').each(function (index) {
                    if (index === 1) {
                        $(this).prop('checked', true).trigger("change", [true]);
                    }
                    removeCheck($(this));
                    $(this).prop('checked', false);
                });
                $no.slideUp(300);

            }
        });

        /* Czy chorowała Pani kiedykolwiek na chorobę nowotworową? */
        $('[name=' + divNameStr + '\\[cb944f10\\]]').on("change", function () {
            var $yes = $('#' + divNameStr + '_cb944f10_yes');
            if ($('#' + divNameStr + '_cb944f10_0').is(':checked')) {
                $yes.slideDown(300);
            } else {
                $yes.find('input').each(function (index) {
                    if (index === 1) {
                        $(this).prop('checked', true).trigger("change", [true]);
                    }
                    removeCheck($(this));
                    $(this).prop('checked', false);
                });
                $yes.slideUp(300);

            }
        });

        /* Czy proces nowotworowy miał charakter ŁAGODNY? */
        $('[name=' + divNameStr + '\\[a87fa40e\\]]').on("change", function () {
            var $yes = $('#' + divNameStr + '_a87fa40e_yes');
            if ($('#' + divNameStr + '_a87fa40e_0').is(':checked')) {
                $yes.slideDown(300);
            } else {
                $yes.find('input').each(function (index) {
                    if (index === 1) {
                        $(this).prop('checked', true).trigger("change", [true]);
                    }
                    removeCheck($(this));
                    $(this).prop('checked', false);
                });
                $yes.slideUp(300);

            }
        });

        /* Czy zmiana miała charakter ZŁOŚLIWY? */
        $('[name=' + divNameStr + '\\[e634afe1\\]]').on("change", function () {
            var $yes = $('#' + divNameStr + '_e634afe1_yes');
            if ($('#' + divNameStr + '_e634afe1_0').is(':checked')) {
                $yes.slideDown(300);
            } else {
                $yes.find('input').each(function (index) {
                    if (index === 1) {
                        $(this).prop('checked', true).trigger("change", [true]);
                    }
                    removeCheck($(this));
                    $(this).prop('checked', false);
                });
                $yes.slideUp(300);

            }
        });

        $('[name=' + divNameStr + '\\[b9f086ea\\]]').on("change", function (e, isJsChange) {
            if (isJsChange !== true) {
                if ($('#' + divNameStr + '_b9f086ea_0').is(':checked')) {
                    $('#' + divNameStr + '_e88246e7_1').prop('checked', true).trigger("change", [true]);
                }
                if ($('#' + divNameStr + '_b9f086ea_1').is(':checked')) {
                    $('#' + divNameStr + '_e88246e7_0').prop('checked', true).trigger("change", [true]);
                }
            }
        });
        $('[name=' + divNameStr + '\\[e88246e7\\]]').on("change", function (e, isJsChange) {
            if (isJsChange !== true) {
                if ($('#' + divNameStr + '_e88246e7_0').is(':checked')) {
                    $('#' + divNameStr + '_b9f086ea_1').prop('checked', true).trigger("change", [true]);
                }
                if ($('#' + divNameStr + '_e88246e7_1').is(':checked')) {
                    $('#' + divNameStr + '_b9f086ea_0').prop('checked', true).trigger("change", [true]);
                }
            }
        });
    }
});



// WEBPACK FOOTER //
// ./assets/js/fourth.js